import { getContentVendorId, getDefaultVendorId } from './environment';

// Mutable bridge between the stores (which own credentials) and the clients (which
// consume them). Keeps api/ free of any import from stores/ - no circular graph.
// Stores push on every change; clients read per request.

export interface QltCredentials {
  jwt: string | null;
  userId: string | number | null;
}

export interface IzteachCredentials {
  accessToken: string | null;
  refreshToken: string | null;
  userId: string | null;
  vendorId: string;
}

export const qltSession: QltCredentials = { jwt: null, userId: null };

export const izteachSession: IzteachCredentials = {
  accessToken: null,
  refreshToken: null,
  userId: null,
  vendorId: getDefaultVendorId(),
};

export interface SessionHooks {
  // Called on a QLT 401. The auth store wires sign-out here.
  onQltAuthFailure: (message: string) => void;
  onQltSignedOut: () => void;
  // IZTeach credentials are minted by the qlt-signin exchange, so "recovery" means
  // running that exchange again. The session store wires it; returns true on success.
  reauthorizeIzteach: () => Promise<boolean>;
  onIzteachAuthFailure: (message: string) => void;
}

export const sessionHooks: SessionHooks = {
  onQltAuthFailure: () => undefined,
  onQltSignedOut: () => undefined,
  reauthorizeIzteach: () => Promise.resolve(false),
  onIzteachAuthFailure: () => undefined,
};

export function setQltCredentials(jwt: string | null, userId: string | number | null): void {
  qltSession.jwt = jwt;
  qltSession.userId = userId;
}

export function clearQltCredentials(): void {
  setQltCredentials(null, null);
}

export function setIzteachCredentials(next: Partial<IzteachCredentials>): void {
  if (next.accessToken !== undefined) izteachSession.accessToken = next.accessToken;
  if (next.refreshToken !== undefined) izteachSession.refreshToken = next.refreshToken;
  if (next.userId !== undefined) izteachSession.userId = next.userId;
  if (next.vendorId !== undefined) izteachSession.vendorId = next.vendorId;
}

// The tenant the kho screens list (courses, documents): the configured library tenant, else the session's.
export function libraryVendorId(): string {
  return getContentVendorId() || izteachSession.vendorId;
}

export function clearIzteachCredentials(): void {
  izteachSession.accessToken = null;
  izteachSession.refreshToken = null;
  izteachSession.userId = null;
}
